/* eslint-disable react/prop-types */
import React from 'react';

export const XLunfinished = ({ width = '80', height = '80' }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 80 80`}>
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 6.65 30 8.3 30 10 C31.65 10 33.3 10 35 10 C35 11.65 35 13.3 35 15 C36.65 15 38.3 15 40 15 C40 16.65 40 18.3 40 20 C41.65 20 43.3 20 45 20 C45 23.3 45 26.6 45 30 C46.65 30 48.3 30 50 30 C50 36.6 50 43.2 50 50 C48.35 50 46.7 50 45 50 C45 53.3 45 56.6 45 60 C43.35 60 41.7 60 40 60 C40 61.65 40 63.3 40 65 C38.35 65 36.7 65 35 65 C35 66.65 35 68.3 35 70 C33.35 70 31.7 70 30 70 C30 71.65 30 73.3 30 75 C26.7 75 23.4 75 20 75 C20 76.65 20 78.3 20 80 C13.4 80 6.8 80 0 80 C0 78.35 0 76.7 0 75 C-3.3 75 -6.6 75 -10 75 C-10 73.35 -10 71.7 -10 70 C-11.65 70 -13.3 70 -15 70 C-15 68.35 -15 66.7 -15 65 C-16.65 65 -18.3 65 -20 65 C-20 63.35 -20 61.7 -20 60 C-21.65 60 -23.3 60 -25 60 C-25 56.7 -25 53.4 -25 50 C-26.65 50 -28.3 50 -30 50 C-30 43.4 -30 36.8 -30 30 C-28.35 30 -26.7 30 -25 30 C-25 26.7 -25 23.4 -25 20 C-23.35 20 -21.7 20 -20 20 C-20 18.35 -20 16.7 -20 15 C-18.35 15 -16.7 15 -15 15 C-15 13.35 -15 11.7 -15 10 C-13.35 10 -11.7 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#DAC9BF"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 8.3 30 11.6 30 15 C26.7 15 23.4 15 20 15 C20 13.35 20 11.7 20 10 C13.4 10 6.8 10 0 10 C0 13.3 0 16.6 0 20 C1.65 20 3.3 20 5 20 C5 31.55 5 43.1 5 55 C8.3 55 11.6 55 15 55 C15 45.1 15 35.2 15 25 C18.3 25 21.6 25 25 25 C25 34.9 25 44.8 25 55 C23.35 55 21.7 55 20 55 C20 56.65 20 58.3 20 60 C13.4 60 6.8 60 0 60 C0 58.35 0 56.7 0 55 C-1.65 55 -3.3 55 -5 55 C-5 45.1 -5 35.2 -5 25 C-8.3 25 -11.6 25 -15 25 C-15 26.65 -15 28.3 -15 30 C-16.65 30 -18.3 30 -20 30 C-20 36.6 -20 43.2 -20 50 C-18.35 50 -16.7 50 -15 50 C-15 53.3 -15 56.6 -15 60 C-18.3 60 -21.6 60 -25 60 C-25 56.7 -25 53.4 -25 50 C-26.65 50 -28.3 50 -30 50 C-30 43.4 -30 36.8 -30 30 C-28.35 30 -26.7 30 -25 30 C-25 26.7 -25 23.4 -25 20 C-23.35 20 -21.7 20 -20 20 C-20 18.35 -20 16.7 -20 15 C-18.35 15 -16.7 15 -15 15 C-15 13.35 -15 11.7 -15 10 C-13.35 10 -11.7 10 -10 10 C-10 8.35 -10 6.7 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#EDDBD2"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 6.65 30 8.3 30 10 C31.65 10 33.3 10 35 10 C35 13.3 35 16.6 35 20 C36.65 20 38.3 20 40 20 C40 26.6 40 33.2 40 40 C38.35 40 36.7 40 35 40 C35 41.65 35 43.3 35 45 C31.7 45 28.4 45 25 45 C25 35.1 25 25.2 25 15 C21.7 15 18.4 15 15 15 C15 24.9 15 34.8 15 45 C11.7 45 8.4 45 5 45 C5 33.45 5 21.9 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#A13E09"
        transform="translate(30,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 9.9 10 19.8 10 30 C11.65 30 13.3 30 15 30 C15 31.65 15 33.3 15 35 C21.6 35 28.2 35 35 35 C35 33.35 35 31.7 35 30 C36.65 30 38.3 30 40 30 C40 31.65 40 33.3 40 35 C41.65 35 43.3 35 45 35 C45 36.65 45 38.3 45 40 C41.7 40 38.4 40 35 40 C35 41.65 35 43.3 35 45 C28.4 45 21.8 45 15 45 C15 43.35 15 41.7 15 40 C11.7 40 8.4 40 5 40 C5 38.35 5 36.7 5 35 C3.35 35 1.7 35 0 35 C0 31.7 0 28.4 0 25 C-1.65 25 -3.3 25 -5 25 C-5 18.4 -5 11.8 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#862F00"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 9.9 10 19.8 10 30 C13.3 30 16.6 30 20 30 C20 20.1 20 10.2 20 0 C23.3 0 26.6 0 30 0 C30 9.9 30 19.8 30 30 C28.35 30 26.7 30 25 30 C25 31.65 25 33.3 25 35 C18.4 35 11.8 35 5 35 C5 33.35 5 31.7 5 30 C3.35 30 1.7 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#FFFFFF"
        transform="translate(25,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C11.65 10 13.3 10 15 10 C15 13.3 15 16.6 15 20 C16.65 20 18.3 20 20 20 C20 26.6 20 33.2 20 40 C18.35 40 16.7 40 15 40 C15 43.3 15 46.6 15 50 C11.7 50 8.4 50 5 50 C5 46.7 5 43.4 5 40 C6.65 40 8.3 40 10 40 C10 33.4 10 26.8 10 20 C8.35 20 6.7 20 5 20 C5 16.7 5 13.4 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#D2C5BF"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 3.3 10 6.6 10 10 C11.65 10 13.3 10 15 10 C15 16.6 15 23.2 15 30 C13.35 30 11.7 30 10 30 C10 31.65 10 33.3 10 35 C6.7 35 3.4 35 0 35 C0 23.45 0 11.9 0 0 Z "
        fill="#9C3802"
        transform="translate(55,20)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C23.3 5 26.6 5 30 5 C30 8.3 30 11.6 30 15 C26.7 15 23.4 15 20 15 C20 13.35 20 11.7 20 10 C13.4 10 6.8 10 0 10 C0 11.65 0 13.3 0 15 C-3.3 15 -6.6 15 -10 15 C-10 11.7 -10 8.4 -10 5 C-6.7 5 -3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F0E1D9"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 9.9 10 19.8 10 30 C6.7 30 3.4 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#8E4C3A"
        transform="translate(35,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 11.65 0 13.3 0 15 C-6.6 15 -13.2 15 -20 15 C-20 11.7 -20 8.4 -20 5 C-13.4 5 -6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#1B0803"
        transform="translate(50,55)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 8.25 10 16.5 10 25 C8.35 25 6.7 25 5 25 C5 21.7 5 18.4 5 15 C1.7 15 -1.6 15 -5 15 C-5 11.7 -5 8.4 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#8F4D3C"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C11.65 5 13.3 5 15 5 C15 6.65 15 8.3 15 10 C13.35 10 11.7 10 10 10 C10 11.65 10 13.3 10 15 C8.35 15 6.7 15 5 15 C5 16.65 5 18.3 5 20 C1.7 20 -1.6 20 -5 20 C-5 16.7 -5 13.4 -5 10 C-1.7 10 1.6 10 5 10 C5 8.35 5 6.7 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#4C1B00"
        transform="translate(55,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C8.3 5 11.6 5 15 5 C15 6.65 15 8.3 15 10 C16.65 10 18.3 10 20 10 C20 11.65 20 13.3 20 15 C13.4 15 6.8 15 0 15 C0 13.35 0 11.7 0 10 C-1.65 10 -3.3 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#AE7F73"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C11.65 10 13.3 10 15 10 C15 13.3 15 16.6 15 20 C11.7 20 8.4 20 5 20 C5 16.7 5 13.4 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#E8D0C3"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 9.9 5 19.8 5 30 C3.35 30 1.7 30 0 30 C0 20.1 0 10.2 0 0 Z "
        fill="#3C1208"
        transform="translate(55,25)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 4.95 10 9.9 10 15 C8.35 15 6.7 15 5 15 C5 13.35 5 11.7 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#9B3600"
        transform="translate(10,40)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#0A0400"
        transform="translate(30,75)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CCC4BF"
        transform="translate(30,70)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#722800"
        transform="translate(30,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#31180A"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#100600"
        transform="translate(75,30)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 3.3 10 6.6 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#A03D08"
        transform="translate(10,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z "
        fill="#8C3100"
        transform="translate(65,30)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B16034"
        transform="translate(30,10)"
      />
      <path
        d="M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#56473F"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#5D2000"
        transform="translate(50,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#A9776A"
        transform="translate(25,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C1.7 10 -1.6 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F4E9E3"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#0A0400"
        transform="translate(50,70)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#100600"
        transform="translate(20,70)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#CBC3BF"
        transform="translate(50,65)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#D6C7BF"
        transform="translate(20,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#0A0400"
        transform="translate(70,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#E0CBBF"
        transform="translate(10,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#210B00"
        transform="translate(5,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#E6CDBF"
        transform="translate(5,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#AD582A"
        transform="translate(10,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#4E3C33"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#F1E2DA"
        transform="translate(10,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#544841"
        transform="translate(5,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#230E02"
        transform="translate(70,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z "
        fill="#E3CCBF"
        transform="translate(65,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A9776A"
        transform="translate(45,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#9D3700"
        transform="translate(35,20)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A74B19"
        transform="translate(50,15)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#EBD6CB"
        transform="translate(50,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B66A41"
        transform="translate(30,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F4E8E2"
        transform="translate(20,10)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#3C291E"
        transform="translate(50,5)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#5B524D"
        transform="translate(20,5)"
      />
      <path
        d="M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#675D57"
        transform="translate(30,0)"
      />
      <path
        d="M0 0 C1.98 0 3.96 0 6 0 C5.67 1.65 5.34 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F4E9E3"
        transform="translate(30,5)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#0A0400"
        transform="translate(60,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#581F00"
        transform="translate(45,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#160800"
        transform="translate(15,65)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#0A0400"
        transform="translate(65,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C9C3BF"
        transform="translate(60,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#0B0401"
        transform="translate(45,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#290D05"
        transform="translate(30,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#8A3000"
        transform="translate(25,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#1A0900"
        transform="translate(10,60)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#792A00"
        transform="translate(55,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#170703"
        transform="translate(50,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#541A0B"
        transform="translate(25,55)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#752900"
        transform="translate(60,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#210A04"
        transform="translate(55,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#792B17"
        transform="translate(20,50)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#642300"
        transform="translate(65,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#8C3100"
        transform="translate(60,45)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#7D2C00"
        transform="translate(65,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A54816"
        transform="translate(10,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#EAD4C8"
        transform="translate(5,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#3F2A1E"
        transform="translate(0,40)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A74B19"
        transform="translate(15,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B97049"
        transform="translate(10,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F1E2DA"
        transform="translate(5,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#5A4C44"
        transform="translate(0,30)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B3643A"
        transform="translate(15,25)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#7E321E"
        transform="translate(55,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B3877B"
        transform="translate(45,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#9C6253"
        transform="translate(30,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C58968"
        transform="translate(15,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#F4E8E2"
        transform="translate(10,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#5F544E"
        transform="translate(5,20)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#31180A"
        transform="translate(65,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#A84D1C"
        transform="translate(30,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#B5683F"
        transform="translate(25,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C78C6D"
        transform="translate(20,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#594F4A"
        transform="translate(10,15)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#30190D"
        transform="translate(60,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#C1805D"
        transform="translate(30,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#59504B"
        transform="translate(15,10)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#645B57"
        transform="translate(20,5)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#5E524B"
        transform="translate(40,0)"
      />
      <path
        d="M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z "
        fill="#6E6560"
        transform="translate(30,0)"
      />
    </svg>
  );
};
